import React, {ReactElement, ReactNode} from 'react';

import {CheckedCircleIcon, CheckedIcon} from '../Icons';
import './CheckpointItem.scss';

export enum Icon {
  TICKED_CIRCLE = 'CheckedCircleIcon',
  TICK = 'CheckedIcon',
}

export enum IconColor {
  BLUE = 'blue',
  YELLOW = 'yellow',
}

interface Props {
  children?: ReactNode;
  className?: string;
  iconColor?: IconColor;
  icon: Icon;
}

function CheckpointItem({children, className, iconColor, icon}: Props): ReactElement {
  const getIcon = () => {
    switch (icon) {
      case Icon.TICK:
        return CheckedIcon;

      default:
      case Icon.TICKED_CIRCLE:
        return CheckedCircleIcon;
    }
  };

  const IconComponent = getIcon();

  return (
    <div className={`checkpointItem ${className || ''}`.trim()}>
      <IconComponent
        className={`checkpointItem__icon ${iconColor ? `checkpointItem__icon--${iconColor}` : ''}`.trim()}
      />
      <div className="checkpointItem__content">{children}</div>
    </div>
  );
}

export default CheckpointItem;
